import { ScrollRestoration } from 'src/modules/scroll/types/ScrollRestoration';
import { createTrigger } from 'src/utils/createTrigger';

export const SCROLL_RESTORE = createTrigger<ScrollRestoration>('SCROLL_RESTORE');
